/* Ensures the callback function given as a parameter is called.
 * This is useful when using callbacks on events tracking systems like
 * GA, because those systems never ensure that hitCallbacks will be called.
 */
const createFunctionWithTimeout = (callback, opt_timeout) => {
  var called = false;
  function fn() {
    if (!called) {
      called = true;
      callback();
    }
  }
  setTimeout(fn, opt_timeout || 1000);
  return fn;
}

const Tracking = {
  event: (options = {}) => {
    // google analytics tracking
    if (options.ga_disabled !== false) {
      if (window.ga && ga.loaded) {
        const eventInfo = { hitType: 'event', eventCategory: options.category, eventAction: options.action, eventLabel: options.label, eventValue: options.value };
        
        // if we have a callback after sending the event, we define it here with a timeout to ensure call
        if (typeof(options.hitCallback) !== "undefined") {
          eventInfo.hitCallback = createFunctionWithTimeout(() => options.hitCallback());
        }

        // now, we can send the event
        ga('send', eventInfo);
      }
    }

    // insights tracking
    if (options.insights_disabled !== false) {
      if (window.adInsights && window.adInsights.__version__ !== undefined) {
        const callback = (typeof(options.hitCallback) !== "undefined") ? createFunctionWithTimeout(() => options.hitCallback()) : null;
        window.adInsights.e(
          options.category, options.action, options.label, options.value, options.version, callback
        );
      }
    }
  },
  setPage: (location) => {
    if (window.ga && ga.loaded) {
      ga('set', 'page', location);
    }
  },
  pageview: (options) => {
    // google analytics tracking
    if (options.ga_disabled !== false) {
      if (window.ga && ga.loaded) {
        ga('send', 'pageview'); // note that you need to call setPage first for virtual pageviews
      }
    }

    // insights tracking
    if (options.insights_disabled !== false) {
      if (window.adInsights && window.adInsights.__version__ !== undefined) {
        if (options.url) {
          window.adInsights.p({url: options.url});
        } else {
          window.adInsights.p();
        }
      }
    }
  }
}

export const getQueryParameter = (parameterName) => {
  var result = null,
      tmp = [];
  location.search
      .substr(1)
      .split("&")
      .forEach(function (item) {
        tmp = item.split("=");
        if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
      });
  return result;
}

export default Tracking;
